import * as React from 'react';
import Nav from 'containers/NavContainer';
import ErrorBoundary from 'ui-components/ErrorBoundary';

interface FrameProps{
	children: Array<any>;
	ready: boolean;
	fetchData?: () => void;
}

const Frame: React.FC<FrameProps> = ({ children, ready, fetchData }) => {
	React.useEffect(() => {
		// Fetch works and artists data when the app loads
		if (fetchData) {
			fetchData();
		}
	}, [fetchData]);

	return (
		<div className="frame">
			<ErrorBoundary>
				{children}
				<Nav/>
			</ErrorBoundary>
		</div>
	);
};

export default Frame;
